const truck = {
    typeId: "",
    number: "",
    brandTypeId: "",
    carId: "",
};

export { truck };
